import React from 'react';
import PropTypes from 'prop-types';

const FiltersPopupMobileBottom = ({ applyLabel, onClose }) => (
  <section className='ken-plp__filters__mobile-popup__bottom'>
    <button
      type='button'
      className='ken-button ken-button--primary--small'
      onClick={onClose}
    >
      {applyLabel}
    </button>
  </section>
);

FiltersPopupMobileBottom.propTypes = {
  applyLabel: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default FiltersPopupMobileBottom;
